import Highcharts from "../../Components/Highcharts";
import moment from "moment";
import { SalesReporting } from "./SalesReporting";
import useChartOptions from "../../system/useChartOptions";
import formatNumber from "../../system/formatNumber";

interface Props {
	reporting: SalesReporting
}

export default ({ reporting }: Props) => {
	const [options, formatters] = useChartOptions();

	return (
		<Highcharts
			options={{
				...options,
				tooltip: {
					formatter: function () {
						return formatters.default(this,
							`Woche vom ${moment(this.x).format("DD. MMMM YYYY")}`,
							!!this.y ? `${formatNumber(this.y)}` : "-"
						);
					}
				},
				series: [
					{
						name: "Verkäufe",
						type: "column",
						data: reporting.histogram.map(h => ({
							y: h.count,
							x: moment(h.date).valueOf()
						}))
					}
				]
			}}
		/>
	);
}
